module.exports = __webpack_public_path__ + "img/perfect_money_icon.e0b27822.png";